<template>
  <div class="ksm-deepzoom__page-wrapper ksm-flex-column">
    <!-- <div v-if="showLoading" style="margin:50px 50px; z-index: 100; position:absolute;">
      <img src="~icons/loading.gif" style="height:20px">
    </div>-->

    <div class="ksm-fabricview__toolbar">
      <photoshop-picker
        v-if="showColorPicker"
        v-model="backgroundColor"
        @ok="actionOk"
        @cancel="actionCancel"
        @input="changeBackgroundColor"
        style="position:absolute; z-index:100"
      />
      <div ref="osdButtonsDiv" class="ksm-disable-select osdButtonsDiv"></div>
      <input type="file" accept=".json" style="display:none" id="loadSetup" />
      <div class="ksm-flex">
        <div class="ksm-fabricview__btn" @click="resetCanvas" title="Komposition neu">
          <div v-html="$_getSvg('komposition-neu.svg')"></div>
        </div>
        <div class="ksm-fabricview__btn" @click="openFilemanager" title="Komposition öffnen">
          <div v-html="$_getSvg('konfiguration_oeffnen.svg')"></div>
        </div>
        <div class="ksm-fabricview__btn" @click="speichern" title="Komposition speichern">
          <div v-html="$_getSvg('konfiguration_speichern.svg')"></div>
        </div>
        <div class="ksm-fabricview__btn" @click="exportieren" title="Komposition exportieren">
          <div v-html="$_getSvg('komposition-exportieren.svg')"></div>
        </div>
        <div class="ksm-fabricview__btn" @click="removeObject" title="löschen">
          <div v-html="$_getSvg('komposition-loeschen.svg')"></div>
        </div>
        <div class="ksm-fabricview__btn" @click="vordergrundObject" title="in den vordergrund">
          <div v-html="$_getSvg('ebene-tiefer.svg')"></div>
        </div>
        <div class="ksm-fabricview__btn" @click="hintergrundObject" title="in den hintergrund">
          <div v-html="$_getSvg('ebene-hoeher.svg')"></div>
        </div>
        <div class="ksm-fabricview__btn" @click="showColorPicker=true">
          <div v-html="$_getSvg('farbe-waehlen.svg')"></div>
        </div>
      </div>
    </div>
    <div class="ksm-deepzoom__page ksm-flex-1" :style="'background-color:'+backgroundColor">
      <div class="ksm-position-absolute ksm-flex">
        <div :id="containerId" class="ksm-deepzoom__body"></div>
      </div>
    </div>
    <div style="display:none">
      <div ref="infobox_template" class="ksm-gummi__end-overlay" :class="modusOption.key">
        <div class="__head ksm-flex">
          <div class="__title ksm-flex-1 ksm-flex"></div>
          <div class="__close-infobox">x</div>
        </div>
        <div class="__body"></div>
      </div>
      <div ref="popup-menu_template" class="ksm-deepzoom__popupmenu-overlay">
        <div class="ksm-flex">
          <div class="ksm-deepzoom__popupmenu__color-rect"></div>
          <div class="ksm-deepzoom__popup-menuitem"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import '../vendor/openseadragon/openseadragon.min';
import CanvasOverlay from "../utils/openseadragon.canvasOverlay";
import "../utils/openseadragon-fabricjs-overlay";
import { fabric } from "fabric";
import { Photoshop } from "vue-color";
import { queryPromise } from "../api";

import {
  Observable,
  Subject,
  ReplaySubject,
  fromEvent,
  of,
  range,
  from,
  pipe
} from "rxjs";

import { map, debounceTime, distinctUntilChanged } from "rxjs/operators";

export default {
  props: {
    seiten: {
      type: Array
    },
    seiteIdx: {
      type: Number
    },
    modusOption: {
      type: Object
    }
  },
  components: {
    "photoshop-picker": Photoshop
  },
  data() {
    return {
      stopDobbledrawTranscripts: false,
      inChangingMerz: false,
      openedSeite: null,
      transcripts: [], //trainscipt mit Inhalten
      mouseRelatedTranscriptIDs: null,
      mouseTargetTranscripts: null,
      showColorPicker: false,
      backgroundColor: "#CBBBA2",
      backgroundColorBak: "#CBBBA2",
      hasImage: false
    };
  },
  watch: {
    seiten() {
      if (this.hasImage) {
        return;
      }
      //update tiles
      if (this.viewer) {
        this.inChangingMerz = true;
        this.viewer.open(this.tiles);
      }
    },

    seite(seite, oldSeite) {
      if (this.hasImage) {
        return;
      }

      //update Page
      if (!seite) {
        return;
      }
      if (this.inChangingMerz) {
        this.inChangingMerz = false;
        return;
      }
      if (this.viewer) {
        this.viewer.clearOverlays();
      }
      if (this.stopDobbledrawTranscripts) {
        this.stopDobbledrawTranscripts = false;
        return;
      }
      this._openPage(seite.idx);
    }
  },
  mounted: function() {
    this._initViewer();
    const vue = this;
    $("#loadSetup")
      .on("change", function(e) {
        let file = e.target.files[0];
        if (file) {
          vue.clickLoadBtn(file);
        }
      })
      .on("click", function() {
        this.value = null;
      });
  },

  computed: {
    // seite
    seite() {
      if (this.seiteIdx != undefined && this.seiten) {
        return this.seiten[this.seiteIdx];
      }
      // this.stopDobbledrawTranscripts = true;
    },
    // watch docs
    docs() {
      if (!this.seite) {
        return;
      }
      return this.seite.$_docInfo;
    },

    tiles() {
      if (!this.seiten) {
        return;
      }
      return this.seiten.map(d => {
        return d.deepSrc;
      });
    },
    containerId() {
      return this.$_getRandomId();
    },

    isKomposition() {
      return this.modusOption.key === "komposition";
    }
  },
  methods: {
    /*************************************************************
     *********/

    openFilemanager() {
      if (
        !window.File ||
        !window.FileReader ||
        !window.FileList ||
        !window.Blob
      ) {
        alert("Your browser does not support load local file.");
        return;
      }

      $("#loadSetup").trigger("click");
    },

    clickLoadBtn(file) {
      if (!file) {
        return;
      }

      const reader = new FileReader();
      const vue = this;
      reader.onloadend = function(e) {
        vue.loadFromJSON(JSON.parse(reader.result));
      };
      reader.readAsText(file);
    },

    async loadFromJSON(json) {
      const map = new Map();
      for (const imgObj of json.objects) {
        const [trID, fileName] = imgObj.id.split("#");
        if (!map.get(fileName)) {
          const att = await queryPromise("attachment/" + fileName);
          if (att) {
            map.set(fileName, att.tag);
          } else {
            continue;
          }
        }

        const res = await this.$store.dispatch("fetchtranscriptCropImg", {
          id: trID,
          tag: map.get(fileName)
        });
        imgObj.src = "data:Image/png;base64," + res;
      }

      const canvas = this.fabricjsOverlay.fabricCanvas();
      canvas.loadFromJSON(
        json,
        function() {
          canvas.renderAll();
        }
        // function(o, object) {
        // }
      );
    },

    resetCanvas() {
      const canvas = this.fabricjsOverlay.fabricCanvas();
      canvas.clear();
      this._setBackground();
      // return;
      // for (const obj of canvas.getObjects()) {
      //   canvas.remove(obj);
      // }
      // for (const obj of canvas.getObjects()) {
      //   canvas.remove(obj);
      // }
    },

    speichern() {
      const canvas = this.fabricjsOverlay.fabricCanvas();
      const json = canvas.toJSON(["id"]);
      json.objects.forEach(obj => {
        obj.src = "";
      });

      let fileName = "komposition_";

      fileName += new Date()
        .toISOString()
        .replace("T", "_")
        .split(".")[0];
      fileName += ".json";

      const data = JSON.stringify(json);
      const textFileAsBlob = new Blob([data], {
        type: "text/json"
      });

      if ("msSaveOrOpenBlob" in navigator) {
        navigator.msSaveOrOpenBlob(textFileAsBlob, fileName);
      } else {
        const downloadLink = document.createElement("a");
        downloadLink.download = fileName;
        downloadLink.innerHTML = "Download File";
        downloadLink.href = window.URL.createObjectURL(textFileAsBlob);
        downloadLink.onclick = function(e) {
          document.body.removeChild(e.target);
        };
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
      }
    },

    exportieren() {
      const fabricCanvas = this.fabricjsOverlay.fabricCanvas();
      $("<a>")
        .attr({
          href: fabricCanvas.toDataURL(),
          download:
            new Date()
              .toISOString()
              .replace("T", "_")
              .split(".")[0] + ".png"
        })[0]
        .click();
    },

    changeBackgroundColor(color) {
      this.backgroundColor = color.hex;
      this._setBackground();
    },
    actionOk() {
      this.showColorPicker = false;
      this.backgroundColorBak = this.backgroundColor;
    },
    actionCancel() {
      this.showColorPicker = false;
      this.backgroundColor = this.backgroundColorBak;
      this._setBackground();
    },
    hintergrundObject() {
      const fabricCanvas = this.fabricjsOverlay.fabricCanvas();
      const active = fabricCanvas.getActiveObject();
      if (active) {
        fabricCanvas.sendToBack(active);
        fabricCanvas.discardActiveObject();
        fabricCanvas.renderAll();
      }
    },
    vordergrundObject() {
      const fabricCanvas = this.fabricjsOverlay.fabricCanvas();
      const active = fabricCanvas.getActiveObject();
      if (active) {
        fabricCanvas.bringToFront(active);
        fabricCanvas.discardActiveObject();
        fabricCanvas.renderAll();
      }
    },
    removeObject() {
      const fabricCanvas = this.fabricjsOverlay.fabricCanvas();
      const active = fabricCanvas.getActiveObject();
      if (active) {
        fabricCanvas.remove(active);
      }
    },
    _setImageBorder() {
      if (!this.fabricjsOverlay) {
        return;
      }

      // const imageSize = this.viewer.world.getItemAt(0).getContentSize();
      // const viewport = this.viewer.viewport;
      // const size = viewport.imageToViewportCoordinates(
      //   viewport.pixelFromPoint(imageSize)
      // );
      // console.log(size);
      // const rect = new fabric.Rect({
      //   width: size.x,
      //   height: size.y,
      //   fill: 'transparent',
      //   stroke: 'black',
      //   strokeWidth: 1
      // });
      // rect.selectable = false;
      // this.fabricjsOverlay.fabricCanvas().add(rect);
    },

    _setBackground() {
      if (!this.fabricjsOverlay) {
        return;
      }
      this.fabricjsOverlay
        .fabricCanvas()
        .setBackgroundColor(this.backgroundColor);
      this.fabricjsOverlay.fabricCanvas().renderAll();
      return;
      // const vue = this;
      // const globalAlpha = this.modusOption.transparenz;
      // const canvasoverlay_marked = this.canvasoverlay_marked;
      // canvasoverlay_marked.resize();
      // canvasoverlay_marked.onRedraw = function() {
      //   const ctx = canvasoverlay_marked.context2d();
      //   ctx.fillStyle = vue.backgroundColor;
      //   ctx.globalAlpha = globalAlpha;
      //   ctx.fillRect(
      //     0,
      //     0,
      //     canvasoverlay_marked.imgWidth,
      //     canvasoverlay_marked.imgHeight
      //   );
      //   ctx.globalAlpha = 0.7;
      //   ctx.strokeStyle = 'rgba(153,0,0,7)';
      // };
      // canvasoverlay_marked.resize();
      // canvasoverlay_marked._updateCanvas();
    },

    /*************************************************************
     *********/
    _openPage(idx) {
      const vue = this;
      setTimeout(function() {
        vue.viewer.goToPage(idx);
      }, 300);
    },

    /*************************************************************
     *********/
    _initViewer() {
      const tiles = this.tiles;
      const vue = this;
      const viewerContanier = vue.$el.querySelector("#" + this.containerId);
      vue.viewerContanier = viewerContanier;

      const isKomposition = this.isKomposition;
      const viewer = new OpenSeadragon({
        element: viewerContanier,
        prefixUrl: "./static/openseadragon_images/",
        tileSources: tiles,
        initialPage: vue.seiteIdx,
        toolbar: vue.$refs.osdButtonsDiv,
        showRotationControl: isKomposition ? false : true,
        autoHideControls: false,
        showSequenceControl: false,
        minZoomImageRatio: 0.2,
        gestureSettingsTouch: {
          pinchRotate: true
        },
        sequenceMode: true
      });

      viewer.setControlsEnabled(false);

      viewer.gestureSettingsMouse.clickToZoom = false;
      viewer.addHandler("open", function(event) {
        vue.hasImage = true;
        viewer.clearOverlays();
        vue._setBackground();
        // vue._setImageBorder();
        // const imageSize = viewer.world.getItemAt(0).getContentSize();
        // const div = document.createElement('div');
        // div.style.top = '0px';
        // div.style.border = '1px solid red';
        // div.style.position = 'absolute';
        // viewer.addOverlay({
        //   element: div,
        //   px: 0,
        //   py: 0,
        //   width: imageSize.x,
        //   height: imageSize.y
        // });

        const openedSeite = vue.seiten.find(s => {
          return s.deepSrc === event.source;
        });
        // const div = document.createElement("div");
        // div.style.left = "648px";
        // div.style.top = "0px";
        // div.style.width = "100px";
        // div.style.height = "200px";
        // div.style.border = "1px solid red";
        // div.style.position = "absolute";
        // viewerContanier.appendChild(div);
        vue.openedSeite = openedSeite;
        if (openedSeite.$_allTranscripts) {
          vue.$emit("imageOpened");
          return;
        }

        vue.$store.dispatch("fechtSeiteDocs", openedSeite).then(res => {
          if (vue.modusOption.key === "ansicht") {
            return;
          }
          if (openedSeite.$_allTranscripts) {
          }

          vue.$emit("imageOpened");
        });
      });

      viewer.addHandler("zoom", function() {
        vue.$emit("eventFromOSDViewer", {
          type: "zoom",
          zoom: viewer.viewport.getZoom(),
          center: viewer.viewport.getCenter()
        });
      });

      viewer.addHandler("canvas-drag", function() {
        vue.$emit("eventFromOSDViewer", {
          type: "canvas-drag",
          zoom: viewer.viewport.getZoom(),
          center: viewer.viewport.getCenter()
        });
      });

      this.mouseTracker = new OpenSeadragon.MouseTracker({
        element: viewerContanier,
        keyDownHandler: function(e) {
          if (e.keyCode === 46) {
            const fabricCanvas = vue.fabricjsOverlay.fabricCanvas();
            fabricCanvas.remove(fabricCanvas.getActiveObject());
          }
        },
        keyUpHandler: function(e) {}
      }).setTracking(true);

      // vue.canvasoverlay_marked = new CanvasOverlay(viewer, {
      //   clearBeforeRedraw: true,
      //   id: 'marked'
      // });
      this.viewer = viewer;
      this.fabricjsOverlay = this.viewer.fabricjsOverlay({
        scale: 500
      });
      // this._setBackground();
    }
  }
};
</script>

<style lang="scss">
.ksm-deepzoom__page-wrapper {
  @extend .ksm-flex-1;
  position: relative;
  height: 100%;
  background-color: #eee;
}

.ksm-deepzoom__page {
  position: relative;
  width: 100%;
  height: 100%;
}
.ksm-deepzoom__body {
  position: absolute;
  width: 100%;
  height: 100%;
}

// .ksm-gummi__start-overlay {
//   width: 20px;
//   height: 20px;
//   border: 1px solid #fff;
//   opacity: 0.9;
//   z-index: 100;
//   cursor: pointer;
// }

// .ksm-deepzoom__popupmenu-overlay {
//   background-color: #eee;
//   position: absolute;
//   margin-top: 25px;
//   padding: 3px;
//   border: 2px solid #fff;
//   z-index: 3000;
// }

// .ksm-deepzoom__popupmenu__color-rect {
//   width: 10px;
//   height: 10px;
//   margin: 2px 5px;
// }

// .ksm-gummi__end-overlay {
//   background-color: #eee;
//   border: 2px solid $darkGrey;
//   z-index: 2000;
//   width: 220px;
//   font-size: 9pt;
//   line-height: 1.5em;
//   &.draging {
//     z-index: 2001;
//   }
//   border-radius: 5px;
//   -webkit-box-shadow: 9px 7px 13px -1px rgba(0, 0, 0, 0.75);
//   -moz-box-shadow: 9px 7px 13px -1px rgba(0, 0, 0, 0.75);
//   box-shadow: 9px 7px 13px -1px rgba(0, 0, 0, 0.75);
//   @extend .ksm-flex-column;

//   .__head {
//     padding-top: 5px;
//   }
//   .__body {
//     padding: 5px;
//     @extend .ksm-hyphens;
//     max-height: 300px;
//     overflow: auto;
//   }
//   .__close-infobox {
//     padding: 0px 10px;
//     &:hover {
//       cursor: pointer;
//     }
//   }
//   &.untersuchung {
//     a {
//       color: $untersuchung-color !important;
//     }
//   }
// }

// .ksm-gummi__line {
//   stroke: $darkGrey;
//   z-index: 2000;
// }
// .ksm-gummi__start-circle {
//   stroke: $darkGrey;
//   fill: transparent;
// }

// .ksm-deepzoom__popup-menuitem {
//   font-size: 9pt;
//   &:hover {
//     color: blue;
//   }
//   cursor: pointer;
// }

.ksm-fabricview__toolbar {
  @extend .ksm-flex-00auto;
  @extend .ksm-flex;
  position: relative;
  height: 36px;
  justify-content: space-between;
  align-items: center;
  .osdButtonsDiv {
    width: 180px;
    height: 36px;
  }

  .ksm-fabricview__btn {
    height: 26px;
    margin: 2px;
    width: 26px;
    @extend .ksm-flex-xy-center;
    div {
      width: 100%;
      height: 100%;
      svg {
        height: 100%;
        width: 100%;
      }
    }
    cursor: pointer;
  }
}

.edit__btn {
  height: 25px;
  margin: 2px;
  font-size: 0.8em;
}
</style>


// WEBPACK FOOTER //
// FabricView.vue?55cb9149